import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { BlockLink, createBlock, LwBlock, LwBlockGridContainer } from 'redesign';
import { RenderUnsettledUI } from 'shared/components';
import { IconBranchOffices } from 'assets/img';
import { useHqRelativePath } from 'hq/hooks/useHqRelativePath';
import { hqRoutes } from 'hq/Routes';
import { useGetPartnersAsBlocks } from './hooks/use-get-partners';
import { PartnersFilterParams } from './partners.types';
import { partnerRoutePrefix } from '../../../../partner/settings';

export const PartnersList = ({ params }: { params: PartnersFilterParams }) => {
  const getPartnersQuery = useGetPartnersAsBlocks(params.searchFilter);
  const { data, status } = getPartnersQuery;
  const generatePath = useHqRelativePath();

  if (status !== 'success') {
    return <RenderUnsettledUI data={getPartnersQuery} />;
  }

  const blocks = data.map((block) => createBlock(block));

  if (!blocks || blocks.length === 0) {
    return <Typography>Er zijn geen partners gevonden.</Typography>;
  }

  return (
    <LwBlockGridContainer>
      {blocks.map((block) => (
        <Grid item xs={6} md={4} lg={3} key={block.id} aria-label="block-element">
          <BlockLink to={generatePath(hqRoutes.PartnerDetail, { id: block.id })}>
            <LwBlock
              icon={<IconBranchOffices width={24} height={24} />}
              id={block.id}
              title={block.title}
              subtitle={block.subtitle}
              dataBlocks={block.dataBlocks}
              navigateCallback={(event) => {
                event.stopPropagation();
                event.preventDefault();
                window.open(`${partnerRoutePrefix}/${block.id}/shift-planning`);
              }}
              navigateLabel="Naar portal"
            />
          </BlockLink>
        </Grid>
      ))}
    </LwBlockGridContainer>
  );
};
